// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__AZos1","addWidgetButton":"Header_addWidgetButton__3tNyj","dashboardTabs":"Header_dashboardTabs__1YGXA","active":"Header_active__148wE"};